import type { ResultDetail } from '../../../../../../../../graphql/rest-link/types.ts';
import type { SubstitutionMap } from './types.ts';

// teamName is present on the runtime payload but absent from the shared participant type
type Participant = ResultDetail['participant'] & { teamName?: string | null };

type BuildParticipantSubstitutionsParams = {
  participant: Participant;
};

const buildParticipantSubstitutions = ({
  participant,
}: BuildParticipantSubstitutionsParams): SubstitutionMap => ({
  '%PARTICIPANT_NAME%': participant.displayName ?? '',
  '%NAME%': participant.name ?? '',
  '%BIB_NUMBER%': participant.bib || '',
  '%TEAM_NAME%': participant.team || participant.teamName || '',
});

export default buildParticipantSubstitutions;
